module.exports = __webpack_public_path__ + "img/inapp-notification.8b09b9fc.svg";